module.exports = ".hide{\r\n    width:0px!important;\r\n    min-width:0px!important;\r\n    max-width:0px!important;\r\n    padding:0px;margin:0px;border-color:transparent;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0106-mail/a-mailtask-create.component.css
// module id = ./src/app/a0106-mail/a-mailtask-create.component.css
// module chunks = main